import { apiClient, apiClientAuth } from "../config/httpClient";


export function OrderApi (contentType = "application/json")
{
    const http = apiClient(contentType);
    // const https = apiClientAuth(contentType);

    return {

        insert : (data) => http.post("/api/order", data),

        // findOne: (id) => https.get(`/api/message/${id}`),

        // findAll: () => https.get(`/api/message`),


      };
}

